import React from "react"

const Linkedin = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="21"
    viewBox="0 0 22 21"
  >
    <g
      id="Linkedin-group"
      data-name="Linkedin-group"
      transform="translate(-1 -1)"
    >
      <path
        id="Linkedin"
        data-name="Linkedin"
        d="M16,8a6,6,0,0,1,6,6v7H18V14a2,2,0,0,0-4,0v7H10V14a6,6,0,0,1,6-6Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <rect
        id="Rectangle_15"
        data-name="Rectangle 15"
        width="4"
        height="12"
        transform="translate(2 9)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <circle
        id="Ellipse_1"
        data-name="Ellipse 1"
        cx="2"
        cy="2"
        r="2"
        transform="translate(2 2)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  </svg>
)

export default Linkedin
